import React from 'react';
import { useHistory } from 'react-router-dom';
import { PageLayout } from 'containers/layout';
import PaymentMethodList from 'containers/payment/PaymentMethodList';

function PaymentMethods() {
  const history = useHistory();

  return (
    <PageLayout title="Payments" back>
      <PaymentMethodList onBack={() => history.goBack()} />
    </PageLayout>
  );
}

export default PaymentMethods;
